export const version = '2.89.0' // bump-client-version 2026-06-23T16:49:33.359Z
